import { App } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface.js';
import type { ModalStaticFunctions } from 'antd/es/modal/confirm.js';
import type { NotificationInstance } from 'antd/es/notification/interface.js';

let message: MessageInstance;
let notification: NotificationInstance;
let modal: Omit<ModalStaticFunctions, 'warn'>;

export default () => {
  const staticFunction = App.useApp();
  message = staticFunction.message;
  modal = staticFunction.modal;
  notification = staticFunction.notification;
  return null;
};

export { message, modal, notification };
